import bootbox from 'bootbox';
import Dropzone from "dropzone";
import formula_functions from './formula_functions';
import builder from "./builder-componenets";

$(document).ready(function (e) {

    let $body = $('body'),
        _automation_id = $('input[name="_automation_btn"]').val();

    if (_automation_id && _automation_id.length) {
        let $btn = $(`.trigger-btn-automation[data-id="${_automation_id}"]`),
            record = $btn.attr('data-record-id'),
            message = $btn.attr('data-message'),
            automation_id = $btn.attr('data-automation');
        triggerAutomation(_automation_id, record, automation_id, message);
    }

    $('.sortable-mapping').sortable({
        cursor: 'grab',
        connectWith: ".sortable-mapping"
    });

    $('.section-text-picker').colorpicker({
        format: "hex",
        autoInputFallback: false,
        useAlpha: true
    });

    $('.trigger-btn-automation').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');
        $(`input[name="_automation_btn"]`).val(id);
        $('.save-record-only').trigger('click');
    });

    function triggerAutomation(id, record, automation_id, message) {
        setTimeout(function (e) {
            $.ajax({
                type: 'POST',
                url: '/automations/trigger',
                data: {
                    id,
                    record,
                    automation_id
                },
                success: function (res) {
                    if (res) {
                        if (message.length) {
                            bootbox.alert({
                                message: message,
                                callback: function () {
                                    window.location.reload();
                                }
                            })
                        } else {
                            window.location.reload();
                        }
                    }
                }
            });
        }, 1000);
    }

    $('#button-action').on('change', function (e) {
        let value = $(this).val(),
            $related_table = $('.related-table-holder'),
            table = $('.create-button-form').data('id'),
            $related = $('#button-related-table'),
            $display_pages = $('.display-page-holder'),
            $button_mapping_holder = $('.button-mappings-holder'),
            $section_holder = $('.section-holder'),
            $section_position_holder = $('.section-position-holder'),
            $action_type_holder = $('.save-record-holder'),
            $section_text_holder = $('.section-text-holder'),
            $section_text_position_holder = $('.section-text-position-holder'),
            $section_text_color_holder = $('.section-text-color-holder'),
            $button_search_field_holder = $('.button-search-field-holder'),
            $primary_field_holder = $('.button-primary-field-holder'),
            $message_holder = $('.btn-message-holder'),
            $position_holder = $('.button-position-holder'),
            $multi_field_holder = $('.multi-field-holder'),
            $specify_record_holder = $('.specify-records-holder'),
            $template_holder = $('.template-holder');

        $button_mapping_holder.empty();
        $('#button-multi-field').empty();

        if (value === 'Create' || value === 'Duplicate' || value === 'DuplicateTable') {
            $action_type_holder.removeClass('d-none');
        } else {
            $action_type_holder.addClass('d-none');
        }

        console.log(value);

        if (value === 'SectionInsertTab') {
            $section_holder.removeClass('d-none');
            $section_position_holder.removeClass('d-none');
            $section_text_holder.removeClass('d-none');
            $section_text_position_holder.removeClass('d-none');
            $section_text_color_holder.removeClass('d-none');
            $position_holder.addClass('d-none');
            $message_holder.addClass('d-none');
            $button_search_field_holder.addClass('d-none');
        } else if (value === 'BarcodeScanner') {
            $section_holder.removeClass('d-none');
            $section_position_holder.addClass('d-none');
            $section_text_holder.addClass('d-none');
            $section_text_position_holder.addClass('d-none');
            $section_text_color_holder.addClass('d-none');
            $button_search_field_holder.removeClass('d-none');
            $message_holder.removeClass('d-none');
            $position_holder.removeClass('d-none');
        } else {
            $section_holder.addClass('d-none');
            $section_position_holder.addClass('d-none');
            $section_text_holder.addClass('d-none');
            $section_text_position_holder.addClass('d-none');
            $section_text_color_holder.addClass('d-none');
            $button_search_field_holder.addClass('d-none');
            $primary_field_holder.addClass('d-none');
            $message_holder.addClass('d-none');
            $position_holder.addClass('d-none');
        }

        if (value === 'QuickAdd' || value === 'SectionInsertTab') {
            $multi_field_holder.removeClass('d-none');
            $specify_record_holder.removeClass('d-none');
            $template_holder.removeClass('d-none');
        } else {
            $multi_field_holder.addClass('d-none');
            $specify_record_holder.addClass('d-none');
            $template_holder.addClass('d-none');
        }

        if (value === 'QuickAdd' || value === 'SectionInsertTab' || value === 'BarcodeScanner') {
            $display_pages.addClass('d-none');
        } else {
            $display_pages.removeClass('d-none');
        }

        if (value === 'QuickAdd') {
            $related.val(table).trigger('change');
            $related_table.addClass('d-none');
        } else if (value === 'Create' || value === 'SectionInsertTab') {
            $related_table.removeClass('d-none');
            $related.val('').trigger('change');
        } else if (value === 'DuplicateTable') {
            $related.val(table).trigger('change');
            $related_table.addClass('d-none');
        } else {
            $related.val('').trigger('change');
            $related_table.addClass('d-none');
        }

        if (value === 'Email') {
            $('.save-button-holder').addClass('d-none');
            $('#compose-button').removeClass('d-none');
        } else {
            $('.save-button-holder').removeClass('d-none');
            $('#compose-button').addClass('d-none');
        }
    });

    $(document).on('change', '.search-field', function (e) {
        let id = $(this).val();

        if (id.length) {

        }
    });

    $('.cancel-btn-save').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-table-id');
        window.location = `/tables/${id}/buttons`;
    });

    $('#button-related-table').on('change', function (e) {
        let related_table = $('#button-related-table').val(),
            table = $('.create-button').attr('data-table-id');

        if (related_table.length && table.length) {
            populateButtonMappings();
            populateMultiRecordFields();
            populateTemplates();
        } else {
            $('.button-mappings-holder').empty();
        }
    });

    $('#button-pages').on('change', function (e) {
        let value = $(this).val();

        if (value.includes('New') || value.includes('Edit') || value.includes('Browse')) {
            $('.button-position-holder').removeClass('d-none');
        } else {
            $('.button-position-holder').addClass('d-none');
        }
    });

    $('#button-action, #button-pages, #button-position').on('change', function (e) {
        let action = $('#button-action').val(),
            pages = $('#button-pages').val(),
            position = $('#button-position').val(),
            $show_holder = $('.show-menu-holder');

        if (action === 'Create' && pages.includes('Browse') && position === 'Button') {
            $show_holder.removeClass('d-none');
        } else {
            $show_holder.addClass('d-none');
        }
    });

    $('#section-holder').on('change', function (e) {
        let id = $(this).val(),
            table = $(this).find(':selected').attr('data-related-id'),
            action = $('#button-action').val();

        if (id.length && action === 'BarcodeScanner') {
            $.ajax({
                type: 'GET',
                url: '/tablebuilder/table/fields/dropdown',
                data: {
                    id: table,
                },
                success: function (res) {
                    $('#search-field').empty().append(res);
                }
            });

            populateButtonMappings();
        } else if (action === 'BarcodeScanner') {
            $('.button-mappings-holder').empty();
            $('#search-field').empty();
        }
    });

    $('#search-field').on('change', function (e) {
        let id = $(this).val(),
            type = $(this).find(':selected').attr('data-type'),
            table = $(this).find(':selected').attr('data-related-table');

        if (id.length && type === 'relationship') {
            $('.button-primary-field-holder').removeClass('d-none');
            $.ajax({
                type: 'GET',
                url: '/tablebuilder/table/fields/dropdown',
                data: {
                    id: table,
                },
                success: function (res) {
                    $('#primary-column').empty().append(res);
                }
            });
        } else {
            $('.button-primary-field-holder').addClass('d-none');
            $('#primary-column').empty();
        }
    });

    $('.delete-button').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');
        bootbox.confirm("Are you sure you want to delete this button?", function (result) {
            if (result) {
                $.ajax({
                    type: 'DELETE',
                    url: '/tables/button',
                    data: {
                        id
                    },
                    success: function (res) {
                        if (res) {
                            window.location.reload();
                        }
                    }
                });
            }
        });
    });

    $('.btn-visibility').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id'),
            show = $(this).data('visibility') === 1 ? 0 : 1;

        $(this).data('visibility', show);

        if (show) {
            $(this).find('.far').removeClass('fa-eye-slash').addClass('fa-eye');
        } else {
            $(this).find('.far').removeClass('fa-eye').addClass('fa-eye-slash');
        }

        $.ajax({
            type: 'POST',
            url: '/tables/button/visibility',
            data: {
                id,
                visible: show
            },
            success: function (res) {
                toastr.success(translation.button_visibility_updated);
            }
        });
    });

    $('.lock-button').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id'),
            is_default = $(this).data('default') === 1 ? 0 : 1,
            $deleteBtn = $(this).siblings('.delete-button');

        $(this).data('default', is_default);

        if (is_default) {
            $(this).find('.fa').removeClass('fa-unlock').addClass('fa-lock');
            $deleteBtn.addClass('d-none');
        } else {
            $(this).find('.fa').removeClass('fa-lock').addClass('fa-unlock');
            $deleteBtn.removeClass('d-none');
        }

        $.ajax({
            type: 'POST',
            url: '/tables/button/lock',
            data: {
                id,
                is_default: is_default
            },
            success: function (res) {
                toastr.success(translation.button_updated);
            }
        });
    });

    $(document).on('click', '.execute-button-action', function (e) {
        e.preventDefault();

        let button_id = $(this).attr('data-id'),
            resource_id = $(this).attr('data-record-id'),
            is_related = $(this).attr('data-is-related') ? parseInt($(this).attr('data-is-related')) : 0,
            section_id = $(this).attr('data-section-id'),
            table_id = $(this).attr('data-table-id'),
            action_type = $(this).attr('data-action-type'),
            target = $(this).attr('data-target'),
            is_calendar_page = $('#calendar').length > 0,
            is_in_edit_modal = $(this).closest('#create-modal').length > 0,
            is_duplicate_in_modal = is_in_edit_modal && !is_calendar_page && !is_related && (action_type === 'Duplicate' || action_type === 'DuplicateTable'),
            show_inline_modal = is_calendar_page || is_duplicate_in_modal,
            $this = $(this);

        // Open a new window in advance, but only if we expect a URL to be returned
        let win = null;
        let expectNewWindow = !is_related && !show_inline_modal; // Open only if not appending DOM elements

        if (expectNewWindow) {
            win = window.open("", '_blank'); // Pre-open for Safari
        }

        $.ajax({
            type: 'POST',
            url: '/tables/button/execute',
            data: {
                button_id,
                resource_id,
                is_related,
                section_id,
                table_id,
                target
            },
            success: function (res) {
                if (res.status) {
                    if (res.message.length) {
                        toastr.success(res.message);
                    }

                    if (show_inline_modal) {
                        if (is_calendar_page) {
                            window.showEventEditModal(res.id);
                        } else {
                            if ($('.browse-table').length) {
                                window.updateBrowseRow(table_id, res.id);
                            }

                            // Swapping content in an already-open modal is invisible, so the
                            // toastr above confirming the duplicate goes unnoticed - close the
                            // modal first and reopen it with the duplicated record once the
                            // close finishes, so the user sees a distinct new popup appear.
                            let $create_modal = $('#create-modal');
                            $('#create-record').attr('data-duplicated', '0');
                            $create_modal.one('hidden.bs.modal', function () {
                                window.showRecordEditModal(table_id, res.id, true);
                            });
                            $create_modal.modal('hide');
                        }
                        return;
                    }

                    if (is_related && res.dom.length) {
                        // Case: Appending to DOM (No new window required)
                        $this.parents('tbody').append(res.dom);
                        formula_functions.executeFormulas();
                        if (win) win.close(); // Close the pre-opened window if it exists
                    } else {
                        // Case: Opening a URL (Avoid Safari popup blocking)
                        if (res.urls && res.urls.length) {
                            if (win) win.close();
                            $.each(res.urls, function (index, url) {
                                window.open(url, '_blank');
                            });
                        } else {
                            if (res.url) {
                                if (win) {
                                    win.location.href = res.url; // Navigate pre-opened window
                                    win.focus();
                                } else {
                                    window.open(res.url, '_blank');
                                }
                            } else {
                                if (win) win.close(); // Close unnecessary window
                            }
                        }
                    }
                }
            },
            error: function (res) {
                if (win) win.close();
                toastr.error(res.statusText + '. Please check logs for error details.');
            }
        });
    });

    $('.create-button-form').one('submit', handleFormSubmit);

    function handleFormSubmit(e) {
        e.preventDefault();

        let action = $('#button-action').val(),
            payload = [],
            sections_enabled = [],
            section_payload = {},
            error = false;

        $('.related-mapping-holder').each(function (i, $container) {
            updateSectionRecordIndex($container);
        });

        if (action === 'Create' ||
            action === 'DuplicateTable' ||
            action === 'QuickAdd' ||
            action === 'SectionInsertTab' ||
            action === 'BarcodeScanner'
        ) {
            let related_table = $('#button-related-table').val();
            let section_mappings = {};
            $('.single-mapping').each(function (i, $mapping) {
                let mapping_field = $($mapping).find('.mapping-field').val(),
                    target_field = $($mapping).find('.target-field').attr('data-field-id'),
                    mapping_action = $($mapping).find('.mapping-action').val(),
                    $custom_value = $($mapping).find('.custom-value-holder'),
                    $visibility = $($mapping).find('.visibility'),
                    $default_field = $($mapping).find('.default_field');

                let target_field_name = $($mapping).find('.target-field').text().trim();

                if (mapping_action === 'paste' && !mapping_field && action !== 'BarcodeScanner') {
                    alert(`Please select mapping field for ${target_field_name}`);
                    error = true;
                }

                let mapping = {
                    target: target_field,
                    field: mapping_field,
                    action: mapping_action,
                    value: '',
                    type: 'simple',
                    visibility: ''
                };

                if (action === 'BarcodeScanner') {
                    mapping.field = target_field;
                }

                if (action === 'QuickAdd' ||
                    action === 'SectionInsertTab' ||
                    action === 'BarcodeScanner') {
                    mapping.visibility = $visibility.is(':checked') ? 'visible' : 'hidden';
                    if (action === 'BarcodeScanner') {
                        mapping.default = $default_field.is(':checked') ? 'default' : '';
                    }
                }

                if (mapping_action === 'custom') {
                    if ($custom_value.find('.custom-value').length === 2) {
                        mapping.value = $custom_value.find('select.custom-value').val();
                    } else {
                        let $custom = $custom_value.find('.custom-value');
                        if ($custom.attr('data-type') === 'date') {
                            mapping.type = 'date';
                            let days = $custom.parents('.input-group').siblings('.date-actions').find('.days').val();
                            mapping.days = days;
                        } else if ($custom.attr('data-type') === 'datetime') {
                            mapping.type = 'datetime';
                            let days = $custom.parents('.input-group').siblings('.date-actions').find('.days').val(),
                                hours = $custom.parents('.input-group').siblings('.date-actions').find('.hours').val(),
                                minutes = $custom.parents('.input-group').siblings('.date-actions').find('.minutes').val();
                            mapping.days = days;
                            mapping.hours = hours;
                            mapping.minutes = minutes;
                        }
                        if ($custom_value.find('.custom-value').hasClass('html-data-field')) {
                            mapping.value = $custom_value.find('.custom-value').attr('data-html');
                        } else {
                            mapping.value = $custom_value.find('.custom-value').val();
                        }

                        if (mapping.value === 'paste' && !mapping_field) {
                            alert(`Please select mapping field for ${target_field_name}`);
                            error = true;
                        }
                    }
                }

                if (action === 'QuickAdd' || action === 'SectionInsertTab' || action === 'BarcodeScanner') {
                    payload.push(mapping);
                } else {
                    if (mapping_field.length ||
                        mapping_action === 'custom' ||
                        mapping_action === 'primary' ||
                        mapping_action === 'user_company' ||
                        mapping_action === 'product_group'
                    ) {
                        if ($($mapping).parents('.mapping-container').length) {
                            payload.push(mapping);
                        } else if ($($mapping).parents('.section-mappings-container').length) {
                            let section_id = $($mapping).parents('.section-mapping').attr('data-section-id'),
                                table_id = $($mapping).parents('.section-mapping').find('.section-related-table').val(),
                                field_id = $($mapping).parents('.section-mapping').find('.section-related-field').val(),
                                index = $($mapping).parents('.section-record').attr('data-index');
                            if (typeof section_payload[section_id] === 'undefined') {
                                section_payload[section_id] = {
                                    mappings: {},
                                    table: table_id,
                                    field: field_id
                                };
                            }
                            if (typeof section_payload[section_id].mappings[index] === 'undefined') {
                                section_payload[section_id].mappings[index] = [];
                            }
                            section_payload[section_id].mappings[index].push(mapping);
                        }
                    }
                }
            });

            let $related_sections = $('.section-visibility');

            $related_sections.each(function (index, $related_section) {
                let section_id = $($related_section).attr('data-section-id'),
                    table_id = $($related_section).parents('.section-mapping').find('.section-related-table').val(),
                    field_id = $($related_section).parents('.section-mapping').find('.section-related-field').val();

                if (typeof section_payload[section_id] === 'undefined') {
                    section_payload[section_id] = {
                        mappings: [],
                        table: table_id,
                        field: field_id
                    };
                }

                if ($($related_section).is(':checked')) {
                    sections_enabled.push(section_id);
                }
            });

            // console.log(payload);

            $('#button-mappings').val(JSON.stringify(payload));
            $('#section-mappings').val(JSON.stringify(section_payload));
            $('#sections-enabled').val(JSON.stringify(sections_enabled));
        }
        if (!error) {
            // $('.create-button-form').one('submit', handleFormSubmit);
            $(this).submit();
        } else {
            $('.create-button-form').one('submit', handleFormSubmit);
        }
    }

    $body.on('change', '.mapping-field,.mapping-action', function (e) {
        let payload = [],
            action = $('#button-action').val();

        displayCustomFields(this);

        $('.single-mapping').each(function (i, $mapping) {
            let mapping_field = $($mapping).find('.mapping-field').val(),
                target_field = $($mapping).find('.target-field').attr('data-field-id'),
                mapping_action = $($mapping).find('.mapping-action').val(),
                $custom_value = $($mapping).find('.custom-value-holder');

            if (action === 'BarcodeScanner') {
                mapping_field = target_field;
            }

            let mapping = {
                target: target_field,
                field: mapping_field,
                action: mapping_action,
                value: ''
            };

            if (mapping_action === 'custom') {

                if ($custom_value.find('.custom-value').length === 2) {
                    mapping.value = $custom_value.find('select.custom-value').val();
                } else {
                    mapping.value = $custom_value.find('.custom-value').val();
                }
            }

            if (mapping_field.length) {
                payload.push(mapping);
            }
        });

        $('#button-mappings').val(JSON.stringify(payload));
    });

    $body.on('change', '.mapping-action', function (e) {
        displayCustomFields(this);
    });

    $body.on('click', '.remove-custom-value', function (e) {
        e.preventDefault();
        let $mapping = $(this).parents('.single-mapping'),
            $custom_value = $($mapping).find('.custom-value-holder'),
            $mapping_action = $($mapping).find('.mapping-action');

        $custom_value.empty().addClass('d-none');
        $mapping_action.val('').removeClass('d-none');
    });

    $body.on('click', '.add-days, .add-hours, .add-minutes', function (e) {
        e.preventDefault();
        let $value = $(this).parents('.input-group-append').siblings('.value-holder'),
            value = $value.val();

        if (!value.length) {
            value = 0;
        }

        $value.val(parseInt(value) + 1);
    });

    $body.on('click', '.minus-days, .minus-hours, .minus-minutes', function (e) {
        e.preventDefault();
        let $value = $(this).parents('.input-group-append').siblings('.value-holder'),
            value = $value.val();

        if (!value.length) {
            value = 0;
        }

        $value.val(parseInt(value) - 1);
    });

    $body.on('change', '.section-visibility', function (e) {
        let $container = $(this).parents('.section-mapping').find('.related-mapping-holder');
        if ($(this).is(':checked')) {
            $container.removeClass('d-none');
        } else {
            $container.addClass('d-none');
        }
    });

    $body.on('click', '.add-section-record', function (e) {
        let $container = $(this).parents('.section-mapping').find('.related-mapping-holder');

        let $related_table = $container.find('.section-related-table'),
            related_table = $related_table.val(),
            table = $related_table.attr('data-table');

        addSectionMappingRecord(related_table, table, $(this).parents('.section-mapping').find('.section-fields'));
    });

    $body.on('click', '.remove-section-record', function (e) {
        let $container = $(this).parents('.section-fields'),
            $sections = $container.find('.section-record'),
            $record = $(this).parents('.section-record');

        console.log($sections.length);

        if ($sections.length > 1) {
            $record.slideUp('slow', function () {
                $(this).remove();

                updateSectionRecordIndex($container);
            });
        } else {
            alert('You need at least one record for section mappings');
        }
    });

    $body.on('click', '.select-btn-html', function (e) {
        let $field = $(this),
            field_id = $(this).attr('data-id'),
            $html_modal = $('#btn-html-modal'),
            $html_field = $(this).parents('.custom-value-holder').find('.html-data-field'),
            value = $html_field.attr('data-html');
        $('.html-data-field').removeClass('active-html-field')
        $html_field.addClass('active-html-field');
        $html_modal.attr('data-field-id', field_id).modal('show');
        tinymce.get("html-content").setContent(value);
    });

    $body.on('click', '#save-btn-html', function (e) {
        let $html_modal = $('#btn-html-modal'),
            id = $html_modal.attr('data-field-id'),
            $field = $(`#${id}.active-html-field`),
            value = tinymce.get("html-content").getContent(),
            text = tinymce.get("html-content").getContent({format: 'text'});

        $field.attr('data-html', value);
        $field.val(text);
        $html_modal.modal('hide');
    });

    $body.on('click', '#cancel-btn-html-save', function (e) {
        let $html_modal = $('#btn-html-modal');
        $html_modal.modal('hide');
    });

    $body.on('click', '#import-eslog', function (e) {
        e.preventDefault();
        let $eslog_modal = $('#import-eslog-modal');
        $eslog_modal.modal('show');
    });

    $body.on('click', '#import-scanned', function (e) {
        e.preventDefault();
        let $scanned_model = $('#import-scanned-modal');
        $scanned_model.modal('show');
    });

    $body.on('click', '#send-einvoice', function (e) {
        e.preventDefault();
        let $btn = $(this);

        if ($btn.hasClass('disabled')) {
            return;
        }

        bootbox.confirm({
            message: $btn.attr('data-query-message'),
            buttons: {
                confirm: {
                    label: $btn.attr('data-yes'),
                    className: 'btn-primary'
                },
                cancel: {
                    label: $btn.attr('data-no'),
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (!result) {
                    return;
                }

                $btn.addClass('disabled');
                toastr.info($btn.attr('data-sending-message'));

                $.ajax({
                    type: 'POST',
                    url: `/einvoice/${$btn.attr('data-table-id')}/${$btn.attr('data-record')}/send`,
                    success: function (res) {
                        toastr.success(res.message);
                        // Reload so the e-Invoice section shows the new status
                        setTimeout(() => window.location.reload(), 1000);
                    },
                    error: function (xhr) {
                        let message = xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : 'Error';
                        toastr.error(message);
                        // The status and error are stored on the invoice
                        setTimeout(() => window.location.reload(), 3000);
                    }
                });
            }
        });
    });

    $body.on('click', '#upload-ehramba', function (e) {
        e.preventDefault();
        let $ehramba_modal = $('#upload-ehramba-modal');

        let tablesOpt = '<option value="">Select table</option>';
        $.get("/get-all-tables", data => {
            for (let table of data) {
                tablesOpt += `<option value="${table.id}">${table.label}</option>`;
            }
            $('.parse-create-table').html(tablesOpt);
        });
        $ehramba_modal.modal('show');
    });

    $(document).on('change', '.parse-create-table', (e) => {
        let table = $('.parse-create-table').val();

        $('.parse-keys-holder').find('.relation-keys').empty();
        $('.parse-mapping-holder').find('.mapping-data').empty();
        if (table.length) {
            $('.add-parse-key').trigger('click');
            $('.parse-mapping-holder').removeClass('d-none');
        }
    });

    $(document).on('click', '.add-parse-key', (e) => {
        let related_table = $('.parse-create-table').val(),
            curr_table = $('#upload-ehramba').attr('data-table-id'),
            header = $('.relation-keys').find('.row').length === 0 ? 'yes' : 'no';

        $.ajax({
            type: 'GET',
            url: '/tablebuilder/section/primary_key',
            data: {
                related_table: related_table,
                curr_table: curr_table,
                header: header,
                type: 'primary_key'
            },
            success: (res) => {
                $('.parse-keys-holder').find('.relation-keys').append(res);
            }
        });
    });

    $body.on('click', '.add-parse-mapping', (e) => {
        let related_table = $('.parse-create-table').val(),
            curr_table = $('#upload-ehramba').attr('data-table-id'),
            header = $('.mapping-data').find('.row').length === 0 ? 'yes' : 'no',
            $activeField = $('.activeField');

        $.ajax({
            type: 'GET',
            url: '/tablebuilder/mapping/fields',
            data: {
                related_table: related_table,
                curr_table: curr_table,
                header: header,
                field_id: $activeField.attr('data-id')
            },
            success: (res) => {
                $('.parse-mapping-holder').find('.mapping-data').append(res);
            }
        });
    });

    $body.on('click', '#show-ehramba-files', function (e) {
        e.preventDefault();
        let $ehramba_modal = $('#upload-ehramba-modal'),
            record = $('#upload-ehramba').attr('data-record'),
            table = $('#upload-ehramba').attr('data-table-id');

        let win = null;
        win = window.open("", '_blank'); // Pre-open for Safari


        $.ajax({
            type: 'GET',
            url: '/uploads/ehramba',
            data: {
                record,
                table
            },
            success: function (res) {
                if (res) {
                    $.each(res, function (index, file) {
                        if (win) win.close();
                        let url = `/file/ehramba/${file.external_id}`,
                            pdfw = window.open(url, '_blank');
                        if (pdfw !== null) {
                            pdfw.focus();
                        } else {
                            bootbox.alert(translation.popup_blocked);
                        }
                    });
                }
            }
        })
    });

    $body.on('click', '#import-xml', function (e) {
        e.preventDefault();
        let $eslog_modal = $('#import-xml-modal');
        $eslog_modal.modal('show');
    });

    if ($('#ehramba-input').length) {
        let csrfToken = $('meta[name="csrf-token"]').attr('content'),
            $ehramba_errors = $('.ehramba-errors');

        // Initialize Dropzone
        let eslogDropzone = new Dropzone("#ehramba-input", {
            url: "/upload/ehramba",
            method: "post",
            maxFiles: 500,
            parallelUploads: 500,
            acceptedFiles: ".pdf",
            addRemoveLinks: true,
            dictDefaultMessage: "Click here or drop a pdf file to attach.",
            dictInvalidFileType: "Only PDF files are allowed.",
            dictRemoveFile: "Remove file",
            autoProcessQueue: false,
            headers: {
                "X-CSRF-TOKEN": csrfToken
            },
            previewTemplate: `
            <div class="dz-preview dz-file-preview">
                <div class="dz-details">
                    <div class="row align-items-center">
                        <div class="col-7">
                            <div class="row">
                                <div class="col-10 upload-details" >
                                    <b data-dz-name></b>
                                </div>
                                <div class="col-2">
                                    <i class="fa fa-times remove-attachments" data-dz-remove></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="upload-progress">
                                <span class="dz-progress">
                                    <span class="dz-upload" data-dz-uploadprogress></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            `,
        });

        // Event Handlers
        eslogDropzone.on("addedfile", function (file) {
            console.log("File added:", file.name);
            $('.upload-message').removeClass('d-none'); // Show the upload message
            $ehramba_errors.empty();
        });

        eslogDropzone.on("error", function (file, errorMessage, xhr) {
            if (xhr && xhr.responseJSON) {
                console.error("Error Response:", xhr.responseJSON); // Log full response for debugging

                let serverError = xhr.responseJSON.error || xhr.responseJSON.message || "An error occurred.";
                alert(`Error: ${serverError}`);
            } else if (typeof errorMessage === "object") {
                if (errorMessage.error) {
                    let $error = `<div class="text-danger"><b>${file.name}</b> : ${errorMessage.error}</div>`;
                    $ehramba_errors.append($error);
                } else {
                    alert(`Error: ${JSON.stringify(errorMessage)}`);
                }
            } else {
                alert(`Error: ${errorMessage}`);
            }

            eslogDropzone.removeFile(file); // Remove the file on error
        });

        eslogDropzone.on("success", function (file, response) {
            eslogDropzone.removeFile(file); // Reset the Dropzone
            if (response.success) {
                let record = $('#upload-ehramba').attr('data-record');
                // $('#upload-ehramba-modal').modal('hide'); // Close the modal
                // let pdfWindow = window.open(response.url, "_blank"); // Open the response URL
                // pdfWindow.focus();
            } else {
                alert("Upload failed. Please try again.");
            }
        });

        eslogDropzone.on("removedfile", function () {
            $('.upload-message').addClass('d-none'); // Hide the upload message if the file is removed
        });

        eslogDropzone.on("sending", function (file, xhr, formData) {
            let record = $('#upload-ehramba').attr('data-record'),
                table = $('#upload-ehramba').attr('data-table-id'),
                related_fields = {},
                classification = {};

            let keys = [],
                separator = $('#file-name-separator').val(),
                import_type = $('input[name="scenario_option"]:checked').val(), // Get selected scenario
                related_table = $('.parse-create-table').val(),
                relation_keys = [],
                mappings = [];

            $('.parser-key-value').each(function (index, keyElem) {
                let selectedOption = $(keyElem).find('option:selected');
                let value = selectedOption.data('name'),
                    field_type = selectedOption.data('type'),
                    $related_dropdown = selectedOption.parents('.parser-key-row').find('.key-related-column'),
                    $classification = selectedOption.parents('.parser-key-row').find('.parser-radio'),
                    $classificationKey = selectedOption.parents('.parser-key-row').find('.classification-key');
                keys.push(value);

                if($classification.is(':checked')){
                    classification.value = value;
                    classification.type = 'normal';
                }

                if (field_type === 'relationship') {
                    selectedOption = $($related_dropdown).find('option:selected');
                    related_fields[value] = selectedOption.data('name');

                    if($classification.is(':checked')){
                        classification.type = 'relationship';
                        classification.field = $classificationKey.find('option:selected').data('name');
                    }
                }
            });

            if (related_table.length) {
                $('.single-primary-key').each(function (index, keyElem) {
                    let left = $(keyElem).find('.current-primary-key').val(),
                        right = $(keyElem).find('.related-primary-key').val();
                    relation_keys.push([
                        left, right
                    ]);
                });

                $('.single-mapping').each(function (index, keyElem) {
                    let left = $(keyElem).find('.current-table-mapping').val(),
                        right = $(keyElem).find('.related-table-mapping').val();
                    mappings.push([
                        left, right
                    ]);
                });
            }

            formData.append('table', table);
            formData.append('keys', JSON.stringify(keys));
            formData.append('separator', separator);
            formData.append('import_type', import_type); // Add import_type to formData
            formData.append('related_table', related_table);
            formData.append('relation_keys', JSON.stringify(relation_keys));
            formData.append('mappings', JSON.stringify(mappings));
            formData.append('related_fields', JSON.stringify(related_fields));
            formData.append('classification', JSON.stringify(classification));

            if (record && record.length) {
                formData.append("record", record);
            }
        });

        $('#upload-ehramba-btn').on('click', function () {
            if (eslogDropzone.getQueuedFiles().length > 0) {
                eslogDropzone.processQueue(); // Start upload
            } else {
                alert("Please select a file to upload.");
            }
        });

        $('input[name="scenario_option"]').on('change', function () {
            let import_type = $('input[name="scenario_option"]:checked').val();

            if (import_type === 'upload_and_create') {
                $('.ehramba-related-container').removeClass('d-none');
            } else {
                $('.ehramba-related-container').addClass('d-none');
            }
        });

        $('.add-upload-keys').on('click', function (e) {
            e.preventDefault();

            let table = $(this).attr('data-table-id');

            $.ajax({
                type: 'GET',
                url: '/tablebuilder/table/fields/dropdown',
                data: {
                    id: table,
                },
                success: function (res) {
                    const row = `
                        <div class="parser-key-wrapper mb-2">
                            <div class="parser-key-row">
                                <!-- First row -->
                                <div class="d-flex align-items-center">
                                    <select class="form-control form-control-sm me-2 parser-key-value">
                                        ${res}
                                    </select>
                        
                                    <select class="form-control form-control-sm me-2 key-related-column d-none">
                                    </select>
                        
                                    <!-- prevent radio shrinking -->
                                    <input type="radio" name="parser-classification"
                                           class="me-2 ml-2 parser-radio flex-shrink-0">
                        
                                    <i class="fas fa-trash delete-key ml-2 flex-shrink-0" style="cursor:pointer;"></i>
                                </div>
                        
                                <!-- Classification dropdown (full width below) -->
                                <select class="form-control form-control-sm classification-key d-none mt-2 w-100">
                                </select>
                            </div>
                        </div>
                    `;

                    $('.parser-keys').append(row);
                }
            });
        });


        // When main select changes
        $(document).on('change', '.parser-key-value', function () {
            let $selected = $(this);

            // Get the selected <option>
            let selectedOption = $selected.find('option:selected');

            // Get attributes
            let relatedTable = selectedOption.data('related-table'),
                field_type = selectedOption.data('type'),
                $parentWrapper = $selected.closest('.parser-key-wrapper'),
                $related_dropdown = $parentWrapper.find('.key-related-column'),
                $classification_dropdown = $parentWrapper.find('.classification-key'),
                is_classification = $parentWrapper.find('.parser-radio').is(':checked');

            if (field_type === 'relationship') {
                // Populate both dropdowns but keep classification hidden
                $.ajax({
                    type: 'GET',
                    url: '/tablebuilder/table/fields/dropdown',
                    data: { id: relatedTable },
                    success: function (res) {
                        // Populate small dropdown
                        $related_dropdown.html(res).removeClass('d-none');
                        // Populate classification-key but keep hidden
                        $classification_dropdown.html(res);
                        if(is_classification){
                            $classification_dropdown.removeClass('d-none');
                        }else{
                            $classification_dropdown.addClass('d-none');
                        }
                    }
                });
            } else {
                // Hide and clear both
                $related_dropdown.empty().addClass('d-none');
                $classification_dropdown.empty().addClass('d-none');
            }
        });

        $(document).on('change', '.parser-radio', function () {
            let $radio = $(this),
                $wrapper = $radio.closest('.parser-key-wrapper'),
                field_type = $radio.parents('.parser-key-row').find('.parser-key-value').find('option:selected').data('type');

            console.log(field_type);

            // Hide all classification dropdowns first
            $('.classification-key').addClass('d-none');

            // Show only the one belonging to this radio
            if ($radio.is(':checked') && field_type === 'relationship') {
                $wrapper.find('.classification-key').removeClass('d-none');
            }
        });

        // Event delegation to handle dynamically added delete buttons
        $(document).on('click', '.delete-key', function () {
            $(this).closest('.parser-key-row').remove();
        });
    }

    if ($('#eslog-input').length) {
        let csrfToken = $('meta[name="csrf-token"]').attr('content');

        // Initialize Dropzone
        let eslogDropzone = new Dropzone("#eslog-input", {
            url: "/import/eslog",
            method: "post",
            maxFiles: 1,
            acceptedFiles: ".xml",
            addRemoveLinks: true,
            dictDefaultMessage: "Click here or drop an XML file to attach.",
            dictInvalidFileType: "Only XML files are allowed.",
            dictRemoveFile: "Remove file",
            headers: {
                "X-CSRF-TOKEN": csrfToken
            },
            previewTemplate: `
           <div class="dz-preview dz-file-preview">
                <div class="dz-details">
                    <div class="row">
                        <div class="col-7">
                            <div class="row">
                                <div class="col-10 upload-details">
                                    <b data-dz-name></b>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="upload-progress">
                                <span class="dz-progress">
                                    <span class="dz-upload" data-dz-uploadprogress></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `,
        });

        // Event Handlers
        eslogDropzone.on("addedfile", function (file) {
            console.log("File added:", file.name);
            $('.upload-message').removeClass('d-none'); // Show the upload message
        });

        eslogDropzone.on("error", function (file, errorMessage, xhr) {
            if (xhr && xhr.responseJSON) {
                console.error("Error Response:", xhr.responseJSON); // Log full response for debugging

                let serverError = xhr.responseJSON.error || xhr.responseJSON.message || "An error occurred.";
                alert(`Error: ${serverError}`);
            } else if (typeof errorMessage === "object") {
                console.error("Error Message Object:", errorMessage);
                alert(`Error: ${JSON.stringify(errorMessage)}`);
            } else {
                alert(`Error: ${errorMessage}`);
            }

            eslogDropzone.removeFile(file); // Remove the file on error
        });

        eslogDropzone.on("success", function (file, response) {
            if (response.success) {
                let record = $('#import-eslog').attr('data-record');
                $('#import-eslog-modal').modal('hide'); // Close the modal
                if (record.length) {
                    window.location.reload();
                } else {
                    let pdfWindow = window.open(response.url, "_blank"); // Open the response URL
                    pdfWindow.focus();
                }
            } else {
                alert("Upload failed. Please try again.");
            }
            eslogDropzone.removeFile(file); // Reset the Dropzone
        });

        eslogDropzone.on("removedfile", function () {
            $('.upload-message').addClass('d-none'); // Hide the upload message if the file is removed
        });

        eslogDropzone.on("sending", function (file, xhr, formData) {
            let record = $('#import-eslog').attr('data-record'),
                table = $('#import-eslog').attr('data-table-name');
            formData.append('table', table);
            if (record.length) {
                formData.append("record", record);
            }
        });
    }

    if ($('#scanned-input').length) {
        let csrfToken = $('meta[name="csrf-token"]').attr('content');

        // Initialize Dropzone
        let scannedDropzone = new Dropzone("#scanned-input", {
            url: "/import/scanned",
            method: "post",
            maxFiles: 1,
            acceptedFiles: ".txt",
            addRemoveLinks: true,
            dictDefaultMessage: "Click here or drop a file to attach.",
            dictInvalidFileType: "Only XML files are allowed.",
            dictRemoveFile: "Remove file",
            headers: {
                "X-CSRF-TOKEN": csrfToken
            },
            previewTemplate: `
           <div class="dz-preview dz-file-preview">
                <div class="dz-details">
                    <div class="row">
                        <div class="col-7">
                            <div class="row">
                                <div class="col-10 upload-details">
                                    <b data-dz-name></b>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="upload-progress">
                                <span class="dz-progress">
                                    <span class="dz-upload" data-dz-uploadprogress></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `,
        });

        // Event Handlers
        scannedDropzone.on("addedfile", function (file) {
            console.log("File added:", file.name);
            $('.upload-message').removeClass('d-none'); // Show the upload message
        });

        scannedDropzone.on("error", function (file, errorMessage, xhr) {
            if (xhr && xhr.responseJSON) {
                console.error("Error Response:", xhr.responseJSON); // Log full response for debugging

                let serverError = xhr.responseJSON.error || xhr.responseJSON.message || "An error occurred.";
                alert(`Error: ${serverError}`);
            } else if (typeof errorMessage === "object") {
                console.error("Error Message Object:", errorMessage);
                alert(`Error: ${JSON.stringify(errorMessage)}`);
            } else {
                alert(`Error: ${errorMessage}`);
            }

            scannedDropzone.removeFile(file); // Remove the file on error
        });

        scannedDropzone.on("success", function (file, response) {
            if (response.success) {
                window.location.reload();
            } else {
                alert("Upload failed. Please try again.");
            }
            scannedDropzone.removeFile(file); // Reset the Dropzone
        });

        scannedDropzone.on("removedfile", function () {
            $('.upload-message').addClass('d-none'); // Hide the upload message if the file is removed
        });

        scannedDropzone.on("sending", function (file, xhr, formData) {
            let record = $('#import-scanned').attr('data-record'),
                table = $('#import-scanned').attr('data-table-name'),
                field = $('#import-field').val(),
                field_name = $('#import-field').find(':selected').attr('data-field-name');
            formData.append('table', table);
            formData.append('field', field);
            formData.append('field_name', field_name);
            if (record.length) {
                formData.append("record", record);
            }
        });
    }

    if ($('#import-xml-input').length) {
        let csrfToken = $('meta[name="csrf-token"]').attr('content');

        // Initialize Dropzone
        let eslogDropzone = new Dropzone("#import-xml-input", {
            url: "/import/xml",
            method: "post",
            maxFiles: 1,
            acceptedFiles: ".xml",
            addRemoveLinks: true,
            dictDefaultMessage: "Click here or drop an XML file to attach.",
            dictInvalidFileType: "Only XML files are allowed.",
            dictRemoveFile: "Remove file",
            headers: {
                "X-CSRF-TOKEN": csrfToken
            },
            previewTemplate: `
           <div class="dz-preview dz-file-preview">
                <div class="dz-details">
                    <div class="row">
                        <div class="col-7">
                            <div class="row">
                                <div class="col-10 upload-details">
                                    <b data-dz-name></b>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="upload-progress">
                                <span class="dz-progress">
                                    <span class="dz-upload" data-dz-uploadprogress></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `,
        });

        // Event Handlers
        eslogDropzone.on("addedfile", function (file) {
            console.log("File added:", file.name);
            $('.upload-message').removeClass('d-none'); // Show the upload message
        });

        eslogDropzone.on("error", function (file, errorMessage, xhr) {
            if (xhr && xhr.responseJSON) {
                console.error("Error Response:", xhr.responseJSON); // Log full response for debugging

                let serverError = xhr.responseJSON.error || xhr.responseJSON.message || "An error occurred.";
                alert(`Error: ${serverError}`);
            } else if (typeof errorMessage === "object") {
                console.error("Error Message Object:", errorMessage);
                alert(`Error: ${JSON.stringify(errorMessage)}`);
            } else {
                alert(`Error: ${errorMessage}`);
            }

            eslogDropzone.removeFile(file); // Remove the file on error
        });

        eslogDropzone.on("success", function (file, response) {
            if (response.success) {
                let record = $('#import-xml').attr('data-record');
                $('#import-xml-modal').modal('hide'); // Close the modal
                if (record.length) {
                    window.location.reload();
                } else {
                    let pdfWindow = window.open(response.url, "_blank"); // Open the response URL
                    pdfWindow.focus();
                }
            } else {
                alert("Upload failed. Please try again.");
            }
            eslogDropzone.removeFile(file); // Reset the Dropzone
        });

        eslogDropzone.on("removedfile", function () {
            $('.upload-message').addClass('d-none'); // Hide the upload message if the file is removed
        });

        eslogDropzone.on("sending", function (file, xhr, formData) {
            let record = $('#import-xml').attr('data-record');
            if (record.length) {
                formData.append("record", record);
            }
        });
    }

    $body.on('click', '#sync-zzzs', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-record'),
            table_name = $(this).attr('data-table-name'),
            url = '/export/zzzs/personal-plan/live',
            action = $(this).attr('data-action'),
            date = $('input[name="datum_zakljucka_veljavnosti_c"]').val();

        if(table_name === 'PDO_c'){
            url = '/export/zzzs/pdo/live';
        }

        if(action === 'terminate'){
            url = '/export/zzzs/personal-plan/live/terminate';

            if(!date.length){
                toastr.error(translation.datum_zakljucka_veljavnosti_c_not_blank);
                return;
            }
        }

        bootbox.confirm({
            message: translation.do_you_really_want_to_import,
            buttons: {
                confirm: {
                    label: translation.yes,
                    className: 'btn-primary'
                },
                cancel: {
                    label: translation.no,
                    className: 'btn-secondary'
                }
            },
            callback: function (result) {
                if (result) {
                    $.ajax({
                        type: "GET",
                        url: url,
                        data: {
                            id,
                            action: 'send'
                        },
                        success: function (res) {
                            $('#zzzs-status').trigger('click');
                        },
                        error: function (res) {
                            alert(res.responseJSON.errors);
                        }
                    })
                }
            }
        });
    });

    $body.on('click', '#zzzs-status', function(e){
        e.preventDefault();

        let id = $(this).data('record'),
            table_id = $(this).data('table-id'),
            table_name = $(this).data('table-name'),
            type = 1;

        if(table_name === 'PDO_c'){
            type = 2;
        }

        $.ajax({
            type: "GET",
            url: '/export/zzzs/status',
            data: {
                id,
                table_id,
                type
            },
            success: function(res){
                $('#zzzsModalBody').html(res.html);
                $('#zzzsModal').modal('show'); // jQuery modal for BS4
            }
        });
    });
});

function escapeHtml(text) {
    return $('<div>').text(text).html();
}

function displayCustomFields($target) {
    let payload = [],
        action = $('#button-action').val();

    let $mapping = $($target).parents('.single-mapping');

    let $mapping_field = $($mapping).find('.mapping-field'),
        $mapping_action = $($mapping).find('.mapping-action'),
        mapping_field = $($mapping).find('.mapping-field').val(),
        target_field = $($mapping).find('.target-field').attr('data-field-id'),
        mapping_action = $($mapping).find('.mapping-action').val(),
        $custom_value = $($mapping).find('.custom-value-holder');

    if (action === 'BarcodeScanner') {
        mapping_field = target_field;
    }

    let render_field;

    if (mapping_field.length) {
        render_field = mapping_field
    } else {
        render_field = target_field;
    }

    if (mapping_action === 'custom') {
        if (mapping_field === 'id') {
            alert('You cannot select custom value for field ID');
            $custom_value.empty().addClass('d-none');
            $mapping_action.val('paste').removeClass('d-none');
        } else {
            $.ajax({
                type: 'GET',
                url: '/tables/field/render',
                data: {
                    field: render_field
                },
                success: function (res) {
                    if (res) {
                        $mapping_action.addClass('d-none');
                        $custom_value.html(res).removeClass('d-none');

                        $('.selectpicker').selectpicker('refresh');
                    }
                }
            });
        }
    }
}

function populateButtonMappings() {

    let related_table = $('#button-related-table').val(),
        table = $('.create-button').attr('data-table-id'),
        action = $('#button-action').val();

    if (action === 'BarcodeScanner') {
        related_table = $('#section-holder').find(':selected').attr('data-related-id');
    }

    $.ajax({
        type: 'GET',
        url: '/tables/button/mappings',
        data: {
            related_table,
            table,
            action
        },
        success: function (res) {
            $('.button-mappings-holder').empty().append(res);
            $('.mapping-field:first-child').trigger('change');

            $('.sortable-mapping').sortable({
                cursor: 'grab',
                connectWith: ".sortable-mapping"
            });
        }
    });
}

function populateMultiRecordFields() {

    let related_table = $('#button-related-table').val(),
        table = $('.create-button').attr('data-table-id'),
        action = $('#button-action').val();

    $.ajax({
        type: 'GET',
        url: '/tables/button/multi_fields',
        data: {
            related_table,
            table,
            action
        },
        success: function (res) {
            $('#button-multi-field').empty().append(res);
        }
    });
}

function populateTemplates() {

    let related_table = $('#button-related-table').val(),
        table = $('.create-button').attr('data-table-id'),
        action = $('#button-action').val();

    $.ajax({
        type: 'GET',
        url: '/tables/button/templates',
        data: {
            related_table,
            table,
            action
        },
        success: function (res) {
            $('#button-templates').empty().append(res);
        }
    });
}

$(document).on('change', '.section-related-table', function (e) {
    let related_table = $(this).val(),
        table = $(this).attr('data-table');

    populateSectionMappings(related_table, table, $(this).parents('.section-mapping').find('.section-fields'));
});

$(document).on('change', '.default_field', function (e) {
    if ($(this).is(':checked')) {
        $('.default_field:checked').trigger('click');
    }
});

function addSectionMappingRecord(related_table, table, $section) {
    let action = $('#button-action').val();
    $.ajax({
        type: 'GET',
        url: '/tables/section/mappings',
        data: {
            related_table,
            table,
            action,
            trigger: 'add_record'
        },
        success: function (res) {
            $($section).find('.section-record').last().after(res);
            updateSectionRecordIndex($section);
        }
    });
}

function updateSectionRecordIndex($container) {
    $($container).find('.section-record').each(function (index, $record) {
        $($record).attr('data-index', index);
    });
}

function populateSectionMappings(related_table, table, $section) {

    let action = $('#button-action').val();


    $.ajax({
        type: 'GET',
        url: '/tables/section/mappings',
        data: {
            related_table,
            table,
            action
        },
        success: function (res) {
            $($section).empty().append(res);
        }
    });
}


